import { createSlice } from "@reduxjs/toolkit";

const searchInputSlice = createSlice({
    name: "searchInputContent",
    initialState: {
        searchInputContent: "",
    },
    reducers: {
        setSearchInputContent: (state, action) => {
            state.searchInputContent = action.payload;
        },
        clearSearchInputContent: (state) => {
            state.searchInputContent = '';
        },
    },
});

export const { setSearchInputContent , clearSearchInputContent } = searchInputSlice.actions;
export default searchInputSlice.reducer;
